module.exports = __webpack_public_path__ + "img/ico_email--gray.e031e90f.svg";